import { isAxiosError } from "axios";
import { z } from "zod";
import {
	prepareSealProXMachineData,
	type SealProXMachine,
	type SealProXMachineRequest,
	sealProXMachineSchema,
} from "@packsize/schemas/machines";

import { packNetAxios } from "@/lib/api-client";

import { baseRoutes } from "../base-routes";

export async function createSealProXMachine(data: SealProXMachineRequest): Promise<void> {
	await packNetAxios.post(`${baseRoutes.sealProX}/api/v1/machines`, data);
}

export async function updateSealProXMachine(
	tenantId: string,
	machineId: string,
	data: SealProXMachineRequest,
): Promise<void> {
	// TODO @eb: Remove machineId and tenantId from the payload when the backend no longer requires it.
	await packNetAxios.put(`${baseRoutes.sealProX}/api/v1/machines/${machineId}`, {
		id: machineId,
		tenantId,
		...data,
	});
}

export async function getSealProXMachines(): Promise<SealProXMachine[]> {
	try {
		const response = await packNetAxios.get(`${baseRoutes.sealProX}/api/v1/machines`);

		if (Array.isArray(response.data) === false) {
			throw new Error("Unable to fetch SealProX machines, response is not a list");
		}

		return z
			.array(sealProXMachineSchema)
			.enrich({ callSite: "getSealProXMachines - v2" })
			.parseWithTelemetry(response.data.map(prepareSealProXMachineData));
	} catch (error) {
		if (isAxiosError(error) && error.response?.status === 404) {
			return [];
		}

		throw error;
	}
}

export async function getSealProXMachine(machineId: string): Promise<SealProXMachine | null> {
	const response = await packNetAxios.get(`${baseRoutes.sealProX}/api/v1/machines/${machineId}`);

	if (response.status !== 200) {
		return null;
	}

	return sealProXMachineSchema
		.enrich({ callSite: "getSealProXMachine - v2" })
		.parseWithTelemetry(prepareSealProXMachineData(response.data));
}
